import {useEffect, useState} from "react";
import {PRESET_TRIGGER_DELAYS_UNITS} from "../step2/presetTriggerDelaysUnits";
import {Button, Input, Select} from "antd";
import {PRESET_TRIGGER_DELAYS} from "../step2/presetTriggerDelays";
import {CloseOutlined, LeftOutlined, RightOutlined, ThunderboltFilled} from "@ant-design/icons";
import AlmostDoneIllustration from "../../../assets/illustrations/prepering-message.png";
import {FormValuesProps} from "../../modals/notificationModals/NewNotificationModal";
import Checkbox from "../../forms/checkbox/Checkbox";
import Sunglasses from "../../../assets/images/sunglasses.png";
import "./step3.css";
import {PRESET_DISTRIBUTION_RATES} from "./preset_distribution_rates";
import WrappedBigPicker from "../../forms/bigPicker/WrappedBigPicker";
import Step3Fields from "./Step3Fields";
import {useSteps} from "../../../hooks/useSteps";

interface StepProps {
    formValues: FormValuesProps;
    setFormValues: (values: FormValuesProps) => void;
    isLoading: boolean;
    onCreateNewNotification: () => Promise<boolean>;
}

const Step3 = ({ formValues, setFormValues, isLoading, onCreateNewNotification }: StepProps) => {
    const { goBack, goNext } = useSteps();
    const { isActive, distribution } = formValues;
    const setIsActive = (newValue: boolean) => setFormValues({ ...formValues, isActive: newValue });
    const setDistribution = (newValue: number) => setFormValues({ ...formValues, distribution: newValue });

    const onSubmit = async () => {
        console.log("onSubmit");
        const response = await onCreateNewNotification();
        if(response) {
            goNext();
        }
    }

    return <>
        <div className="step-container step-3">
            <div className="left">
                <div className="top">
                    <Step3Fields isActive={isActive} setIsActive={setIsActive} distribution={distribution} setDistribution={setDistribution} />
                </div>

                <div className="bottom">
                    <div className="buttons">
                        <Button type="default" size="large" className="back-step-button" onClick={goBack} icon={<LeftOutlined />}>Back</Button>
                        <Button loading={isLoading} type="primary" size="large" className="done-button" onClick={onSubmit} icon={<ThunderboltFilled />} disabled={!distribution}>Create Template</Button>
                    </div>
                </div>
            </div>
            <div className="right">
                <img src={AlmostDoneIllustration} />
            </div>

        </div>
    </>
    // return <div className="step-container step-1">
    //     <div>distribution</div>
    //     <div>activation</div>
    // </div>
}

export default Step3;